/**************************************************
 * Nombre:       Tarjeta_Piso
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import Tarjeta_Piso from "./Tarjeta_Piso";

const Tarjeta_Torre = ({seleccionada, setSeleccionada, it, habOcupadas}) => {

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>


            <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'center'}>
                <Typography sx={{fontSize: 18, fontWeight: 800, lineHeight: 1.1}}>{it.torre}</Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 3}}>
                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}
                    spacing={2}
                >


                    {it.habsPisos.map((item, index) => {

                        if (!item.habitaciones.length) {
                            return ''
                        } else {
                            return (
                                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                                    <Tarjeta_Piso seleccionada={seleccionada} setSeleccionada={setSeleccionada}
                                                  it={item} habOcupadas={habOcupadas}/>
                                </Grid>
                            )
                        }


                    })}

                </Grid>
            </Grid>

        </Grid>
    )

}
export default Tarjeta_Torre